import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-bottom: 36px;
`

export const Bold = styled.span`
  font-weight: bold;
`